(function () {
    'use strict';

    angular
        .module('app.mentions')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider.state('home.adminMentions', {
                requireLogin: true,
                url: 'mention/mentions',
                templateUrl: 'app/admin/mention/mentions/mentions.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['Administrator', 'Achoo Analyst'],
                    navMarker: ['mention', 'mentions']
                },
                controller: 'mentionsCtrl'
            })
        }]);
})();